import styled from "@emotion/styled";

import { formatKeyCombination, type KeyCombination } from "@skilitics/interact-keyboard";

const Container = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 5px;
`;

const Key = styled.span`
  background: ${({ theme }) => theme.surface};

  padding: 2px 6px;
  border: 1px solid ${({ theme }) => theme.surfaceBack_1};
  border-radius: 4px;

  text-transform: uppercase;
  white-space: nowrap;
`;

type KeyChordProps = {
  keyCombination: KeyCombination;
};

export const KeyChord = ({ keyCombination }: KeyChordProps) => (
  <Container>
    {formatKeyCombination(keyCombination).map((key) => (
      <Key key={key}>{key}</Key>
    ))}
  </Container>
);
